<template>
  <div
    :style="getTextStyle"
    :class="[options.verticalAlign && options.verticalAlign !== 'top' ? 'text-component height-auto' : 'text-component']"
  >
    <!--    <div class="tinymce" :id="uid" v-html="content" @dblclick="tinymceInit" @blur="getContent"></div>-->
    <div
        v-if="!isCXEditor"
      :class="options.handleDefaultMargin ? 'tinymce noMargin':'tinymce'"
      :id="uid"
      v-html="content"
      ref="textInner"
      @click.self
      :contenteditable="isEditStatu"
      @dblclick="dbEditContent($event)"
      @blur="dbChangeContent($event)"
      :style="getPositionStyle"
    ></div>
    <div
        v-if="isCXEditor"
        class="richtext tinymce block"
        :id="'noteEditorContent' + myid.container_id + myid.rect_id"
        :style="getPositionStyle"
    ></div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { historyIgnoreWrap } from "utils/revork"
import {compareIds} from "utils/event/animate";

export default {
  mixins: [eventMixin],
  name: "cxEditor",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean
    }
  },
  data() {
    return {
      reloadTimer: null,
      isEditStatu: false,
      activeIds: undefined,
      uid: null,
      clickNum: 0,
      isCXEditor: true,  //是否使用超星笔记编辑器
      MultiEditorParam: {
        largePreview: true,
        isGetVideoDataFromCenter: true
      }
    }
  },
  mounted() {
    if(this.myid.uid || this.myid.cellId){  //单元格内的富文本沿用之前的逻辑，不采用笔记编辑器
      this.isCXEditor = false
    }
    this.uid = this.$event.getIdsByStrId(this.myid)
    // this.$nextTick(()=>{
    //   this.tinymceInit()
    // })
    if (this.noCacheComponent && !this.options?.filedMapping?.flag && this.options.linkUrl) {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
    if(this.isCXEditor){
      setTimeout(()=>{
        MultiEditor.init("detail") //加载配置文件，编辑页传参 edit，详情页传参 detail
        setTimeout(()=>{
          this.initEditor()
        }, 1000)
      }, 500)
    }
  },
  beforeDestroy() {
    clearInterval(this.reloadTimer)
  },
  watch: {
    // active(newVal,oldVal){
    //   if(newVal){
    //   }else{
    //     if(!tinymce.get(this.uid)){
    //       return
    //     }
    //     this.content =  tinymce.get(this.uid).getContent()
    //     tinymce.remove('#'+this.uid)
    //     // this.clickNum = 0
    //   }
    // }
    "options.content": {
      deep: true,
      handler(newVal, oldVal) {
        if (this.isCXEditor && newVal && newVal !== oldVal) {
          historyIgnoreWrap(() => {
            this.initEditor()
          })()
        }
      }
    },
    "ids":{
      deep:true,
      handler(n,o) {
        if(this.isEditStatu && !compareIds(n,this.myid)){
          this.dbChangeContent()
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    zoom() {
      return this.$store.state[this.request_prefix]?.page?.zoom
    },
    hasHandleNbsp(){
      return this.options.hasHandleNbsp
    },
    content: {
      get() {
        let content = this.options.content
        // console.log("content",content)
        let arrEntities
        if(this.hasHandleNbsp){
          arrEntities = { lt: "<", gt: ">", bsp: " ",amp: "&", qquot: '"', quot: '"' }
          content = content.replace(/&(lt|gt|bsp|amp|qquot|quot);/gi, function (all, t) {
            return arrEntities[t]
          })
        }else{
          arrEntities ={ lt: "<", gt: ">", nbsp: " ", amp: "&", qquot: '"', quot: '"' }
          content = content.replace(/&(lt|gt|nbsp|amp|qquot|quot);/gi, function (all, t) {
            return arrEntities[t]
          })
        }
        // 文字溢出处理
        let str = content
        if (this.options.contentHasLimit && !this.isCXEditor) {
          let direction = str.includes("left")
            ? "left"
            : str.includes("right")
            ? "right"
            : str.includes("center")
            ? "center"
            : ""
          let textAlign = direction ? "text-align: " + direction + ";" : ""
          content =
            str.slice(0, 2) +
            ` class='overflowHidMultiLine' style= '${textAlign}-webkit-line-clamp: ${this.options.textLimitLines}'` +
            str.slice(2)
        }
        // 兼容老数据 替换默认字体
        content = content.replace("默认字体", "PingFang SC 微软雅黑")
        return content
      },
      set(newVal) {
        let val = newVal.replace(/[<>&" ]/g, function (c) {
          return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&qquot;", " ": "&bsp;" }[c]
        })
        this.$changeOptionsEV(true, "hasHandleNbsp", false, undefined, this.myid)
        this.$changeOptionsEV(true, "handleDefaultMargin", false, undefined, this.myid)
        this.$changeOptionsEV(val, "content", false, undefined, this.myid)
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.options.background || !Array.isArray(this.options.background)) {
        return {}
      }
      this.options.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getTextControl() {
      let textoverflow = ""
      if (this.options.textOverFlowType == "scroll") {
        textoverflow = "scroll"
      } else {
        textoverflow = this.options.textOverFlowType
      }
      return {
        "overflow-y": textoverflow ? textoverflow : "hidden",
        "overflow-x": textoverflow === "visible" ? "unset" : "hidden"
      }
    },
    getPositionStyle() {
      let translate = "",
        top = undefined,
        bottom = undefined,
        width = undefined,
        maxHeight = undefined
      const { verticalAlign, textPaddingTypeFlag, padding, paddingTop, paddingBottom, paddingLeft, paddingRight } =
        this.options
      switch (verticalAlign) {
        case "center":
          top = "50%"
          translate = "translateY(-50%)"
          width =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingLeft + paddingRight}px)`
          maxHeight =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingTop + paddingBottom}px)`
          break
        case "bottom":
          bottom = textPaddingTypeFlag === 1 ? `${padding}px` : `${paddingBottom}px`
          width =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingLeft + paddingRight}px)`
          maxHeight =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingTop + paddingBottom}px)`
          break
        default:
      }
      return {
        position: verticalAlign && verticalAlign !== "top" ? "absolute" : "",
        transform: translate,
        top,
        bottom,
        width,
        maxHeight
      }
    },
    getTextStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.bgStyle,
        ...this.getTextControl,
        transform: "rotate(" + this.options.rotate + "deg)",
        // width: this.options.width + "px",
        // height: this.options.height + "px",
        // top: this.options.top,
        // left: this.options.left,
        "z-index": this.options.zIndex,
        padding: this.getPaddingStyle,
        // "border-radius": this.options.borderRadius + "px",
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        // overflow: "auto"
        // "--textoverflow": textoverflow,
        // fontSize: "24px",
        // fontWeight: 600   //默认加粗，取消不了，
      }
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },

    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    }
  },
  methods: {
    dbEditContent() {
      if (this.isBigScreenPreview()) {
        return
      }
      this.isEditStatu = true
      sessionStorage.setItem("isEditStatu", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      this.$nextTick(() => {
        this.getSelectPos()
      })
    },
    // 将光标移动到最后面
    getSelectPos() {
      let esrc = this.$refs.textInner
      let range = document.createRange()
      range.selectNodeContents(esrc)
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    dbChangeContent(event) {
      this.isEditStatu = false
      sessionStorage.removeItem("isEditStatu")
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      this.content = event.target.innerHTML
    },
    initEditor(content) {
      //  加载配置文件
      let thisContent = content || this.content || ""
      // 处理复制粘贴的内容里有rem的情况
      thisContent = thisContent.replace(/style=\".*?\"/g, function(targetStr) {return targetStr.replace(/rem/g, 'em')})
      setTimeout(()=>{
        let _this = this
        let idStr = "noteEditorContent" + _this.myid.container_id + _this.myid.rect_id
        MultiEditor.renderRichtext(idStr, thisContent, null, this.MultiEditorParam)
      }, 500)
    },
  }
}
</script>

<style scoped>
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-component,
.text-component > div {
  width: 100%;
  height: 100%;
  /*transition: transform 0.5s;*/
  word-break: break-word;
  font-size: 16px;
}

.text-component.height-auto {
  position: relative;
}
.text-component.height-auto {
  height: 100% !important;
}
.text-component.height-auto > div {
  height: auto;
}
/*.text-component,*/
/*.text-component > div {*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  transition: transform 0.5s;*/
/*  word-break: break-all;*/
/*  font-size: 24px;*/
/*}*/
.text-component > div {
  /*pointer-events: none;*/
  height: 100%;
  overflow-y: var(--textoverflow);
  text-align: left;
}

::-webkit-scrollbar {
  width: 8px;
}
/* //滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #eaecf1;
  border-radius: 3px;
}
.content {
  /*white-space: pre;*/
  /* height: 100%; */
}
.content:focus {
  outline: none;
}
.edit-content {
  width: 100%;
  height: 100%;
}
.edit-content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}
.c-pointer:hover {
  cursor: pointer;
}

.text-component ::v-deep .el-scrollbar__view {
  margin-bottom: 0;
}
::v-deep strong {
  font-weight: bold;
  font-style: unset;
}
::v-deep i,
::v-deep em {
  font-style: italic;
}
.tinymce{
  display: inline-block;
  width: 100%;
}
.tinymce:focus {
  outline: none;
}
::v-deep .tinymce.noMargin input,
::v-deep .tinymce.noMargin select,
::v-deep .tinymce.noMargin textarea {
  vertical-align: revert;
  /* color: #000; */
  border: revert;
  border: revert;
  outline: revert;
  resize: revert;
}
::v-deep .tinymce.noMargin b,
::v-deep .tinymce.noMargin i,
::v-deep .tinymce.noMargin strong,
::v-deep .tinymce.noMargin em{
  font-weight: revert;
  font-style: revert;
}

::v-deep .tinymce.noMargin *{
  margin: 0;
  padding: 0;
}
  .tinymce.block{
    display: block;
  }
</style>
